import { render, staticRenderFns } from "./Convenzioni.vue?vue&type=template&id=5b1ef121&"
import script from "./Convenzioni.vue?vue&type=script&lang=js&"
export * from "./Convenzioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports